import { createContext } from 'react';

interface RenderBeaconInterface {
  setReady(): void; // call this when the page is ready
  isTimeout: boolean; // this is to flag that the page has really completed first meaningful paint or just a timeout
}

export const RenderBeaconContext = createContext<RenderBeaconInterface>({
  setReady: () => undefined,
  isTimeout: false,
});
